import React from "react";
import PropTypes from "prop-types";
import { VictoryChart, VictoryAxis, VictoryGroup, VictoryBar,
	VictoryLegend, VictoryContainer } from "victory";
import { injectIntl, intlShape } from "react-intl";

import AlmigTheme, { almigOrange, almigBlue } from "../grundelemente/AlmigTheme";

import { getBarParams } from "./AnalyseTools";

import { genDailyMessage } from "./DailyValuesHelpers";
import { checkDailyProps } from "../model/util/DailyValues";
import { compressorTicksShort } from "../model/util/Components";

class SpezifischeLeistungsaufnahmeChart extends React.Component {
	static propTypes = {
		model: PropTypes.object.isRequired,
		timespan: PropTypes.object.isRequired,
		rtc: PropTypes.string.isRequired,
		compressors: PropTypes.arrayOf(PropTypes.object).isRequired,
		refresh: PropTypes.func.isRequired,
		intl: intlShape.isRequired
	};
	
	constructor(props, context) {
		super(props, context);
		checkDailyProps(props);
	}
	componentWillReceiveProps(nextProps) {
		checkDailyProps(nextProps);
	}
	render() {
		const { model, compressors, intl } = this.props;
		let pad_left = 45;
		let { bar_width, bar_offset, domain_padding } = getBarParams(model.data.length, pad_left, 2);

		return (
			<div>
				<VictoryChart theme={AlmigTheme}
					domainPadding={{ x: domain_padding }}
					padding={{ left: pad_left, top: 50, bottom: 20 }}
					containerComponent={<VictoryContainer className="printableAlmigItem"/>}>
					<VictoryLegend x={pad_left} y={0}
						orientation="vertical"
						data={[
							{ name: intl.formatMessage({id: "Total specific power"}), symbol: { fill: almigOrange }},
							{ name: intl.formatMessage({id: "Specific power"}), symbol: { fill: almigBlue }}
						]} />
					<VictoryAxis tickValues={compressorTicksShort(model.data, compressors, intl)} />
					<VictoryAxis dependentAxis />
					<VictoryGroup offset={bar_offset} style={{ data: { width: bar_width }}}>
						<VictoryBar data={model.data} x={d => d.cindex.toString()} y="gesamtspezifische_leistung_kWhm3" color={almigOrange} />
						<VictoryBar data={model.data} x={d => d.cindex.toString()} y="spezifische_leistung_kWhm3" color={almigBlue} />
					</VictoryGroup>
				</VictoryChart>
				{genDailyMessage(model)}
			</div>
		);
	}
}

export default injectIntl(SpezifischeLeistungsaufnahmeChart);
